import { Component, Input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

@Component({
    selector: 'nova-email-container',
    templateUrl: './email-container.component.html',
    styleUrls: ['./email-container.component.scss'],
    standalone: true,
    imports: [MatIconModule]
})
export class EmailContainer {
    @Input()
    email: string | null;

    @Input()
    displayText: string | null;
}
